// Libraries
import FadeIn from "./animations/FadeIn";
import Stagger from './animations/Stagger';

/**
 * This class prepares all general animations
 * Note that then, it's called in setup-scripts.js file
 */
export default class Animations {
  /**
   * Animations constructor
   * @param {HTMLElement} content DON'T USE "document" TO GET HTML ELEMENTS, USE INSTEAD "content"
   */
  constructor(content) {
    this.fadeInElements = content.querySelectorAll(".js-fade-in > div");
    this.animatedModules = content.querySelectorAll(".js-animated > div");
    this.straggerItems = content.querySelectorAll(".js-element-fade-in-up");

    this.triggerFade();
    this.fadeInUpStagger();
  }

  /**
   * This method creates a fadeIn animation for each module
   * and is triggered when scrolling
   */
  triggerFade() {
    const modules = gsap.utils.toArray(this.fadeInElements);

    modules.forEach((module) => {
        const fade = new FadeIn(module,
            { once: false });
      fade.init();
    });
  }


  /**
   * Stragger animation
   */
  fadeInUpStagger() {
      const stagger = new Stagger(this.straggerItems,
          {
              y: 100,
              duration: .3,
              delay: 0,
              stagger: .5
          });
    stagger.staggerOnScroll();
  }
}
